import UserRole from './UserRole';
import UserType from './UserType';
import Office from './Office';

export default class User {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    type: UserType;
    role: UserRole;
    twoFactorEnabled: boolean;
    office: Office;
    manager: User;
    lmsNumber: number;
    defaultPayRate: number;
}



// WEBPACK FOOTER //
// ./src/models/User.ts